<template>
  <v-autocomplete
    :items="allAgentGroups"
    v-model="selectedAgentGroupId"
    :label="label"
    item-text="name"
    item-value="id"
    @change="changeListener($event)"
    :error-messages="errorMessages"
    :disabled="!enabled"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { AGENT_GROUPS_SEARCH_QUERY } from "../../../constants/graphql";

export default {
  name: "AgentGroupSelect",

  props: {
    enabled: {
      type: Boolean,
      default: () => true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    groupId: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: () => "",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    groupsOnly: {
      //https://tracker.globetrack.ie/issues/6175
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => "Agent Group",
    },
  },

  data() {
    return {
      agentGroups: {},
      selectedAgentGroupId: this.value && this.value != "" ? this.value : "",
    };
  },

  computed: {
    allAgentGroups() {
      if (this.agentGroups.edges != null) {
        return [{ name: "All Groups", id: "" }].concat(
          this.agentGroups.edges.map((item) => ({ ...item.node }))
        );
      }
    },
    filter() {
      let filter = { not_in_use_eq: false };
      if (this.groupsOnly) {
        filter["isAgent"] = false;
      }
      return filter;
    },
  },

  watch: {
    value(newVal) {
      this.selectedAgentGroupId = newVal;
    },
  },

  methods: {
    changeListener(data) {
      this.$emit("onSelect", data);
      this.$emit("input", data);
    },
  },

  apollo: {
    agentGroups: {
      query: AGENT_GROUPS_SEARCH_QUERY,
      variables() {
        return {
          filter: this.filter,
        };
      },
      result({ data }) {
        if (this.groupId != "") {
          this.selectedAgentGroupId = data.agentGroups.edges.some(
            (i) => i.node.id === this.groupId
          )
            ? this.groupId
            : "";
        }
      },
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/AgentGroupSelect.vue